import React from "react";

export const SEBI_REGISTRATION_NUMBER = "INH000031134";
export const COMPANY_LEGAL_NAME = "ABillion Analytics";

interface FooterCopyrightProps {
  className?: string;
  variant?: "inline" | "stacked";
}

const FooterCopyright: React.FC<FooterCopyrightProps> = ({
  className,
  variant = "inline",
}) => {
  const currentYear = new Date().getFullYear();

  if (variant === "stacked") {
    return (
      <div
        className={
          className ?? "text-center text-xs sm:text-sm text-gray-500 space-y-1"
        }
      >
        <div>
          &copy; <span suppressHydrationWarning>{currentYear}</span>{" "}
          {COMPANY_LEGAL_NAME}. All rights reserved.
        </div>
        <div className="text-xs text-gray-400">
          SEBI Reg. No.: {SEBI_REGISTRATION_NUMBER}
        </div>
      </div>
    );
  }

  return (
    <div
      className={
        className ??
        "text-center md:text-left flex flex-wrap items-center justify-center md:justify-start gap-x-2 gap-y-0.5"
      }
    >
      <span>
        &copy; <span suppressHydrationWarning>{currentYear}</span>{" "}
        {COMPANY_LEGAL_NAME}. All rights reserved.
      </span>
      <span className="hidden sm:inline">|</span>
      <span>SEBI Reg. No.: {SEBI_REGISTRATION_NUMBER}</span>
    </div>
  );
};

export default FooterCopyright;
